import { useCookies } from 'react-cookie';
import { useCallback, useEffect, useState } from 'react';
import { getCookieValue } from '../utils/cookies';

export const useAuthSessionCookie = (): AuthSessionCookie => {
  const [cookies, setCookie, removeCookie] = useCookies([
    sessionIdCookieName,
    sessionExistsCookieName,
  ]);
  const sessionCookieExists = useCallback(
    () => cookies[sessionExistsCookieName] === 'true',
    [cookies]
  );
  const [isSessionCookiePresent, setIsSessionCookiePresent] = useState(
    sessionCookieExists()
  );

  const removeSessionCookie = () => {
    removeCookie(sessionExistsCookieName, {
      path: '/',
      expires: new Date(0),
    });
  };

  const refreshSessionCookie = () => {
    setCookie(sessionExistsCookieName, getCookieValue(sessionExistsCookieName));
  };

  useEffect(() => {
    setIsSessionCookiePresent(sessionCookieExists());
  }, [cookies, sessionCookieExists]);

  return {
    isSessionCookiePresent,
    refreshSessionCookie,
    removeSessionCookie,
  };
};

const sessionIdCookieName = 'blue-sana-session-id';
export const sessionExistsCookieName = 'blue-sana-session-exists';

interface AuthSessionCookie {
  isSessionCookiePresent: boolean;
  refreshSessionCookie: () => void;
  removeSessionCookie: () => void;
}
